// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DynProperty } from "../../../Commons/DynProperty.js";
import { Color } from "../../../Commons/Graphics.js";
import { Resources } from "../../../Commons/properties/Resources.js";
import { RowPropertyClass } from "./RowPropertyClass.js";


export let VerticalPanelDataProviderItem = function ()
{
    RowPropertyClass.apply(this);
    this.HeaderBackColor = Color.Empty;
    this.HeaderForeColor = Color.Empty;
    this.ValueBackColor = Color.Empty;
    this.ValueForeColor = Color.Empty;
    /// <summary>
    /// завел чтоб создавать если надо типизирование экшн-контролы. (напр. кнопки, линки)
    /// </summary>
    this.DynPropertyControltype = DynProperty.STRING;
    this.GroupIndex = null;
}
VerticalPanelDataProviderItem.prototype = Object.create(RowPropertyClass.prototype);

VerticalPanelDataProviderItem.prototype.Reset = function (Visible)
{
    this.visible = Visible;
    this.HeaderBackColor = this.HeaderForeColor = this.ValueBackColor = this.ValueForeColor = Color.Empty;
}

VerticalPanelDataProviderItem.prototype.Apply = function (sourceItem)
{
    this.visible = sourceItem.visible;
    this.HeaderBackColor = sourceItem.HeaderBackColor;
    this.HeaderForeColor = sourceItem.HeaderForeColor;
    this.ValueBackColor = sourceItem.ValueBackColor;
    this.ValueForeColor = sourceItem.ValueForeColor;
}

VerticalPanelDataProviderItem.prototype.Properties = function ()
{
    let result = new Array();
    let dp = new DynProperty("HeaderColors", new PairColor(this.HeaderForeColor, this.HeaderBackColor), DynProperty.PAIR_COLOR, DynProperty.COLORS_GROUP);
    dp.PropertyComment = Resources.getResource("property.LabelColors");
    result.push(dp);

    dp = new DynProperty("ValueColors", new PairColor(this.ValueForeColor, this.ValueBackColor), DynProperty.PAIR_COLOR, DynProperty.COLORS_GROUP);
    dp.PropertyComment = Resources.getResource("property.ValueColors");
    result.push(dp);
    return result;
}

VerticalPanelDataProviderItem.prototype.callBack = function (v)
{
    let p = DynProperty.getPropertyByName(v, "HeaderColors");
    if (p != null /*&& p.Value is PairColor*/)
    {
        let pairColor = p.Value;

        this.HeaderForeColor = pairColor.Color1;
        this.HeaderBackColor = pairColor.Color2;
    }
    p = DynProperty.getPropertyByName(v, "ValueColors");
    if (p != null && p.Value /*is PairColor*/)
    {
        let pairColor = p.Value;

        this.ValueForeColor = pairColor.Color1;
        this.ValueBackColor = pairColor.Color2;
    }
}
